import { useState } from "react";
import { Menu } from "lucide-react";
import { SIGNUP_URL } from "@/components/landing/constants";

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-nav" className="fixed top-0 inset-x-0 z-50 px-4 md:px-8 pt-4">
      <div className="glass max-w-6xl mx-auto rounded-full px-5 md:px-7 py-3 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 font-display font-black tracking-tight text-lg">
          <span className="relative inline-flex h-8 w-8 items-center justify-center">
            <span className="absolute inset-0 rounded-full conic-ring blur-[2px] opacity-90" />
            <span className="absolute inset-[3px] rounded-full bg-brand-bg" />
            <span className="relative font-mono text-[11px] font-bold text-white">SP</span>
          </span>
          <span>
            SmartPl<span className="text-brand-accent" style={{ fontFamily: "'Times New Roman', Georgia, serif" }}>A</span><span className="text-brand-accent" style={{ fontFamily: "'Times New Roman', Georgia, serif", letterSpacing: "0.5px", fontSize: "1.05em" }}>I</span>te
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-7 text-sm text-white/70 font-medium">
          <a href="#miq" className="hover:text-white transition-colors" data-testid="nav-miq">MIQ</a>
          <a href="#howitworks" className="hover:text-white transition-colors" data-testid="nav-how">How it works</a>
          <a href="#features" className="hover:text-white transition-colors" data-testid="nav-features">Features</a>
          <a href="#pricing" className="hover:text-white transition-colors" data-testid="nav-pricing">Pricing</a>
          <a href="#compare" className="hover:text-white transition-colors" data-testid="nav-compare">Compare</a>
          <a href="#faq" className="hover:text-white transition-colors" data-testid="nav-faq">FAQ</a>
        </nav>
        <a
          href={SIGNUP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta"
          className="hidden md:inline-flex pill bg-white text-black px-5 py-2.5 text-sm font-semibold hover:bg-white/90"
        >
          Start free trial
        </a>
        <button
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
          onClick={() => setOpen(!open)}
          className="md:hidden inline-flex items-center justify-center h-9 w-9 rounded-full bg-white/5 border border-white/10"
        >
          <Menu className="w-4 h-4" />
        </button>
      </div>
      {open && (
        <div className="md:hidden glass mt-2 max-w-6xl mx-auto rounded-3xl p-5 flex flex-col gap-4">
          {[
            ["MIQ", "miq"],
            ["How it works", "howitworks"],
            ["Features", "features"],
            ["Pricing", "pricing"],
            ["Compare", "compare"],
            ["FAQ", "faq"],
          ].map(([label, anchor]) => (
            <a
              key={anchor}
              href={`#${anchor}`}
              onClick={() => setOpen(false)}
              className="text-white/80"
              data-testid={`nav-mobile-${anchor}`}
            >
              {label}
            </a>
          ))}
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-cta"
            className="pill bg-white text-black px-5 py-2.5 text-sm font-semibold text-center"
          >
            Start free trial
          </a>
        </div>
      )}
    </header>
  );
}
